import apiService from './api';
import { Customer, CreateCustomerData, UpdateCustomerData } from '../types/customerTypes';

class CustomerService {
  async getCustomers(): Promise<Customer[]> {
    const response = await apiService.get<Customer[]>('/customers');
    return response.data;
  }

  async createCustomer(data: CreateCustomerData): Promise<Customer> {
    const response = await apiService.post<Customer>('/customers', data);
    return response.data;
  }

  async updateCustomer(data: UpdateCustomerData): Promise<Customer> {
    const { id, ...updateData } = data;
    const response = await apiService.put<Customer>(`/customers/${id}`, updateData);
    return response.data;
  }

  async deleteCustomer(id: string): Promise<void> {
    await apiService.delete(`/customers/${id}`);
  }

  async toggleCustomerStatus(id: string): Promise<Customer> {
    const response = await apiService.patch<Customer>(`/customers/${id}/toggle-status`);
    return response.data;
  }
}

export const customerService = new CustomerService();
export default customerService;